<script setup>
import { ensureMeta, formatDayMin, get, openWin, ymdhm } from '@/common/util'
import { useEntityStructureStore, useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import { getCurrentInstance, reactive } from 'vue'
import Logs from '../config/Logs.vue'
import config from '@/common/config'
const metaStore=useMetaStore()
const props=defineProps(['mem','standalone','mid']),ess=useEntityStructureStore(),emit=defineEmits(['toList','mod','del']),ins=getCurrentInstance()
,meta=reactive({detailcols:{basic:[['mname','mid'],['email','disabled'],['contact','authorities'],['company','cdt'],['dept','authdt'],['jobtitle','lastlogindt']],adsreceive:['agreedemailads','agreedsnssmsads']
  ,inqueries:['oneonone_inquery','roadview_shootinginquiry','applyforanopenapi']},selmem:null})
async function init(){
  meta.inited=false
  meta.selmem=props.mem
  if(props.mid){
    meta.selmem=await get('rest/authed/admin/mem/'+props.mid)
    meta.selmem=meta.selmem.data
  }
  if(props.standalone==='')meta.standalone=true
  else meta.standalone=props.standalone
  let res=await get('rest/authed/admin/memdatacnt/'+meta.selmem.mid)
  meta.memdatacnt=res.data
  meta.datainfoheads=['apiintegration','layers','styles','roadview','roadview_notes']
  if(metaStore.dispmode=='minimum'){
    meta.datainfoheads.splice(0,1)
    meta.detailcols.inqueries=['oneonone_inquery']
  }
  ess.ensureItem('member',ms=>{
    meta.struct=ms
    meta.inited=true
  })
}
init()
defineExpose({init})
</script>
<template>
  <v-card v-if="meta.inited" flat class="manmemdetail">
    <v-card-text class="detailmem">
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <v-row>
                <v-col>{{ $t('basicinformation') }}</v-col>
                <v-spacer/>
                <v-col v-if="!meta.standalone" class="d-flex justify-end"><v-btn color="primary" :text="$t('editmemberinformation')" @click="emit('mod')"/></v-col>
                <v-col v-if="!meta.standalone" cols="2" class="d-flex justify-end"><v-btn color="error" :text="$t('withdrawal')" @click="emit('del')"/></v-col>
              </v-row>
            </v-card-title>
            <v-divider/>
            <v-table>
              <tbody>
                <tr v-for="cols in meta.detailcols.basic">
                  <template v-for="col in cols">
                    <th class="bg-grey-lighten-2 w-25">
                      {{ $t(meta.struct[col].tkey) }}
                    </th>
                    <td v-if="meta.struct[col].type.toLowerCase().includes('date')">
                      {{ dayjs(meta.selmem[col]).isValid()?formatDayMin(meta.selmem[col]):'' }}
                    </td>
                    <td v-else-if="col=='disabled'">
                      {{ $t(meta.selmem[col]?'oinaccessible':'accessible') }}
                    </td>
                    <td v-else-if="col=='authorities'">
                      {{ meta.selmem[col]?$t(meta.selmem[col]):'' }}
                    </td>
                    <td v-else>{{ meta.selmem[col] }}</td>
                  </template>
                </tr>
                <tr>
                  <td class="bg-grey-lighten-2 w-25">{{ $t('temporarypasswords') }}</td>
                  <td>{{ meta.selmem.temppasswd }}</td>
                  <td class="bg-grey-lighten-2 w-25">{{ $t('dateofmod') }}</td>
                  <td>{{ ymdhm(meta.selmem.mdt) }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card>
          <v-card class="mt-3">
            <v-card-title>
              {{ $t('marketingconsent') }}
            </v-card-title>
            <v-table>
              <tbody>
                <tr v-for="col in meta.detailcols.adsreceive">
                  <th class="bg-grey-lighten-2 w-25">{{ $t(meta.struct[col].tkey) }}</th>
                  <td><v-chip :prepend-icon="meta.selmem[col]?'mdi-check':'mdi-cancel'" :color="meta.selmem[col]?'success':''" :text="meta.selmem[col]?'ON':'OFF'"/></td>
                  <th class="bg-grey-lighten-2 w-25">{{ $t('listeningtime') }}</th>
                  <td>{{ formatDayMin(meta.selmem[col+'dt']) }}</td>
                </tr>
              </tbody>
            </v-table>
          </v-card>
          <v-card class="mt-3">
            <v-card-title>
              {{ $t('inquiryapplicationhistory') }}
            </v-card-title>
            <v-table>
              <thead class="bg-grey-lighten-2 text-center">
                <tr>
                  <th v-for="tk in ['separation','all','unprocessed','processed','shortcuts']" class="text-center">{{ $t(tk) }}</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr v-for="col in meta.detailcols.inqueries">
                  <td>{{ $t(col) }}</td>
                  <td>
                    <div v-if="col=='oneonone_inquery'">{{ meta.memdatacnt?.oneonone_total }}</div>
                    <div v-if="col=='roadview_shootinginquiry'">{{ meta.memdatacnt?.roadview_total }}</div>
                    <div v-if="col=='applyforanopenapi'">{{ meta.memdatacnt?.apireq_total }}</div>
                  </td>
                  <td>
                    <div v-if="col=='oneonone_inquery'">{{ meta.memdatacnt?.oneonone_notdone }}</div>
                    <div v-if="col=='roadview_shootinginquiry'">{{ meta.memdatacnt?.roadview_notdone }}</div>
                    <div v-if="col=='applyforanopenapi'">{{ meta.memdatacnt?.apireq_notdone }}</div>
                  </td>
                  <td>
                    <div v-if="col=='oneonone_inquery'">{{ meta.memdatacnt?.oneonone_done }}</div>
                    <div v-if="col=='roadview_shootinginquiry'">{{ meta.memdatacnt?.roadview_done }}</div>
                    <div v-if="col=='applyforanopenapi'">{{ meta.memdatacnt?.apireq_done }}</div>
                  </td>
                  <td>
                    <v-btn v-if="col=='oneonone_inquery'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/manserv/oneonone_inquery')"/>
                    <v-btn v-if="col=='roadview_shootinginquiry'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/manserv/roadview_inquery')"/>
                    <v-btn v-if="col=='applyforanopenapi'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/manserv/applytousetheopenapi')"/>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card>
        </v-col>
        <v-col>
          <v-card :title="$t('aboutdata')">
            <v-table>
              <thead class="bg-grey-lighten-2">
                <tr>
                  <th v-for="tk in ['separation','numberofdata','shortcuts']" class="text-center">{{ $t(tk) }}</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr v-for="key in meta.datainfoheads">
                  <td>{{ $t(key) }}</td>
                  <td v-if="key=='apiintegration'">{{ meta.memdatacnt?.api }}</td>
                  <td v-if="key=='layers'">{{ meta.memdatacnt?.layer }}</td>
                  <td v-if="key=='styles'">{{ meta.memdatacnt?.style }}</td>
                  <td v-if="key=='roadview'">{{ meta.memdatacnt?.streetview }}</td>
                  <td v-if="key=='roadview_notes'">{{ meta.memdatacnt?.memo }}</td>
                  <td>
                    <v-btn v-if="key=='apiintegration'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/mandata/man_ext_api')"/>
                    <v-btn v-if="key=='layers'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/mandata/managelayers')"/>
                    <v-btn v-if="key=='styles'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/mandata/managestyles')"/>
                    <v-btn v-if="key=='roadview'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/mandata/registermanageroadview')"/>
                    <v-btn v-if="key=='roadview_notes'" :text="$t('shortcuts')" @click="openWin(config.frontRoot+'admin/mandata/manageroadviewnotes')"/>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card>
          <v-card class="mt-3">
            <v-card-title>
              <v-row>
                <v-col>{{ $t('viewlogs') }}</v-col>
                <v-spacer/>
                <v-col class="d-flex justify-end"><v-btn :text="$t('viewlogs')" @click="meta.onlog=true"/></v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider v-if="!meta.standalone"/>
    <v-card-actions v-if="!meta.standalone">
      <v-btn variant="elevated" :text="$t('tolist')" @click="emit('toList')"/>
    </v-card-actions>
    <v-overlay contained class="align-center justify-center" v-model="meta.onlog" width="70%">
      <Logs ispop fixmem showtitle :mid="meta.selmem.mid" :mname="meta.selmem.mname" @close-log="meta.onlog=false"/>
    </v-overlay>
  </v-card>
</template>
